import { useEffect, useRef, useState } from 'react';
import makeCancelable from '@justpark/helpers/src/makeCancelable/makeCancelable';

const useLazy = (promise) => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const cancelable = makeCancelable(promise);

    cancelable.promise
      .then((module) => {
        ref.current = module.default;
        setLoaded(true);
      })
      .catch(() => {});

    return () => {
      cancelable.cancel();
    };
  }, [ref, setLoaded, promise]);

  return [loaded, ref];
};

export default useLazy;
